import { render } from "./noData.vue?vue&type=template&id=6899d170&scoped=true"
import script from "./noData.vue?vue&type=script&lang=js"
export * from "./noData.vue?vue&type=script&lang=js"

import "./noData.vue?vue&type=style&index=0&id=6899d170&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-6899d170"

export default script